{
  "hero": {
    "title": "Servicii",
    "cta": "Ia legătura"
  },
  "banner": {
    "message": "Sunt aici pentru orice întrebări",
    "cta": "Ia legătura"
  },
  "services": [
    {
      "number": "01",
      "title": "Producție conținut video și fotografie",
      "description": "Legătura lipsă în afacerile moderne. Produc video și fotografie de înaltă calitate pe care majoritatea agențiilor se așteaptă să le furnizezi tu însuți. Proiectez site-ul tău în jurul conținutului pe care îl filmez.",
      "items": [
        {
          "title": "Povești de brand",
          "description": "Videoclipuri cinematice care umanizează compania ta.",
          "previewVideo": "povesti-brand"
        },
        {
          "title": "Videoclipuri demo produs și explicative",
          "description": "Făcând tehnologia complexă ușor de înțeles.",
          "previewVideo": "demo-produs"
        },
        {
          "title": "Video vertical social-first",
          "description": "Reels, Stories și clipuri TikTok în format portret, din aceeași sesiune de filmare.",
          "previewVideo": "social-first"
        },
        {
          "title": "Fotografie produs și lifestyle",
          "description": "Imagini profesionale pentru site-uri, cataloage, e-commerce și campanii.",
          "previewVideo": "fotografie-produs"
        },
        {
          "title": "Filmări on-location și evenimente",
          "description": "Producție la birou, magazin, cramă sau eveniment live.",
          "previewVideo": "filmari-on-location"
        },
        {
          "title": "Biblioteci de asset-uri",
          "description": "O bancă lunară de fotografii și videoclipuri scurte pentru canale active."
        }
      ]
    },
    {
      "number": "02",
      "title": "Inginerie brand",
      "description": "De la prima schiță până la deploy-ul final. Nu cred în branding \"deconectat\". Construiesc identitatea ta vizuală și vitrina ta digitală ca un singur organism viu.",
      "items": [
        {
          "title": "Design identitate",
          "description": "Logo-uri, tipografie și brand books care se traduc în web."
        },
        {
          "title": "Dezvoltare web de înaltă performanță",
          "description": "Site-uri web codate personalizat, construite pentru conversie și viteză."
        },
        {
          "title": "Site-uri bazate pe conținut",
          "description": "Site-uri structurate în jurul fotografiilor și videoclipurilor pe care le producem împreună."
        },
        {
          "title": "Landing page-uri și microsite-uri de campanie",
          "description": "Pagini dedicate pentru lansări, reclame, parteneriate și generare de lead-uri."
        },
        {
          "title": "Ecosisteme digitale",
          "description": "Asigurarea că brandul tău se simte la fel pe un smartphone precum pe un desktop."
        },
        {
          "title": "Actualizări de conținut vizual",
          "description": "Reîmprospătarea site-ului cu fotografii, videoclipuri noi și campanii sezoniere."
        }
      ]
    }
  ]
}
